import { projectApi } from '@highlight-cp/project-api';

import { useGetCurrentProjectId } from '../use-get-current-project-id';

const useGetProducts = () => {
  const projectId = useGetCurrentProjectId();
  return projectApi.useGetProjectsByProjectIdProductsQuery(
    { projectId: projectId ?? 0 },
    { skip: !projectId },
  );
};

export default useGetProducts;
